<div class="flex justify-content-center">
	<img [src]="imgSrc" [alt]="imgSrc" />
</div>
